import React, { Fragment, useContext, useEffect, useRef, useState } from "react";
import { Alert, ButtonGroup, Card, CardBody, Col, DropdownItem, DropdownMenu, DropdownToggle, FormGroup, Label, Row, Spinner, UncontrolledDropdown } from "reactstrap";
import { Btn, H3, P } from "../../../../AbstractElements";
import { t } from "i18next";
import { ContactContext, SocialDataContext } from "../../ContextProvider";
import InputError from "../../../../Shared/Components/Form/InputError";
import { getContactChargesApi } from "../../../../Shared/Api/GetContactCharges";
import Select from "react-select";
import "./basicData.css"

const BasicData = ({ contactId, register, errors, reset, setValue }) => {
  //state
  const [charges, setCharges] = useState([]);
  const [charge, setCharge] = useState();
  const [isViewUploadMenu, setIsViewUploadMenu] = useState(false);
  const [urlImage, setUrlImage] = useState("");
  const contenedorRef = useRef(null);
  const API_URL = process.env.REACT_APP_API_URL;
  const routeImage = `${API_URL}${process.env.REACT_APP_API_URL_AVATAR}`
  console.log(routeImage);
  
  const [file, setFile] = useState(null);
  const [itemCharged, setItemCharged] = useState(false);

  //context
  const { apiErrors, item, getItem, setItem, setApiErrors, selectImageSocialNetwork, loadingAvatar } = useContext(ContactContext);
  const { item: itemSocial, getItem: getItemSocial } =
    useContext(SocialDataContext);


  //alert
  const [alertOpen, setAlertOpen] = useState(
    apiErrors && apiErrors.length > 0 ? true : false
  );
  useEffect(() => {
    contactId ? getItem(contactId) : setItem({});
    setItemCharged(!itemCharged);
  }, [contactId]);

  useEffect(() => {
    setValue("first_name", item?.first_name);
    setValue("last_name", item?.last_name);
    setValue("contact_charge_id", item?.contact_charge_id);
  }, [itemCharged]);

  const ToggleAlert = () => setAlertOpen(!alertOpen);

  /// manejos del componente
  const fetchCharges = async () => {
    let response = await getContactChargesApi();

    if (response.result === "success") {
      setCharges(response.data.items);
    }
  };

  //usefect
  useEffect(() => {
    setAlertOpen(apiErrors && apiErrors.length > 0 ? true : false);

  }, [apiErrors]);

  useEffect(() => {
    reset({
      first_name: item?.first_name,
      last_name: item?.last_name,
      contact_charge_id: item?.contact_charge_id,

    });
    fetchCharges();
  }, []);

  useEffect(() => {
    setValue("contact_charge_id", item?.contact_charge_id);
    setCharge(charges.find((e) => e.id == item?.contact_charge_id));

  }, [charges]);

  useEffect(() => {
    return () => {
      setItem({});
      setApiErrors([]);
      reset({}, { keepValues: false, keepErrors: false, keepDirty: false });
    };
  }, []);

  const handleChangeCharge = async (event) => {
    let chargeSelected = charges.find((e) => e.id == event?.id);
    setItem({ ...item, charge: chargeSelected });
    setValue("contact_charge_id", event?.id, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    setCharge(chargeSelected);
  };

  useEffect(() => {
    function handleClickAfuera(event) {
      const clicDentroDelContenedor = contenedorRef.current?.contains(event.target);
      const clicEnElementoExcluido = event.target.closest('#excluir-click');

      if (clicEnElementoExcluido && isViewUploadMenu === false) {
        setIsViewUploadMenu(true);

      } else if (clicEnElementoExcluido && isViewUploadMenu == true) {
        setIsViewUploadMenu(false);
        return
      } else if (!clicDentroDelContenedor) {

        setIsViewUploadMenu(false);
        return
      }
    }

    document.addEventListener('mousedown', handleClickAfuera);
    return () => document.removeEventListener('mousedown', handleClickAfuera);
  }, [isViewUploadMenu]);


  const getImage = async (username, type) => {
    try {
      item.avatar_url = null
      const res = await selectImageSocialNetwork(username, type);
      getItem(item.id);
      getItemSocial(item.id);
      return res;
    } catch (error) {
      console.error("Error en getImage:", error);
    }
  };

  const handleUpload = async (file) => {

    try {
      const res = await getImage(file, "storage");
    } catch (err) {
      console.error("Error al subir archivo:", err);
    }
  };

  console.log(item.avatar_url);
  


  return (
    <Fragment>
      <Card>
        <CardBody>
          <Alert
            className="alert-dismissible"
            color="danger inverse"
            isOpen={alertOpen}
            toggle={ToggleAlert}
          >
            <i class="icon-alert"></i>
            {apiErrors && apiErrors.length > 0 ? apiErrors[0] : ""}
          </Alert>

          <Row className="mb-2">
            <div className="profile-title">
              <div className="d-flex">
                <div className="flex-grow-1">
                  <H3
                    attrH3={{
                      className: "mb-1 f-20 txt-primary text-uppercase",
                    }}
                  >
                    {item?.first_name
                      ? `${item.first_name} ${item.last_name}`
                      : "Nuevo contacto"}
                  </H3>
                  <P attrPara={{ className: "text-uppercase f-12" }}>
                    {item?.charge ? `${item.charge?.name}` : ""}
                  </P>
                </div>
              </div>
            </div>
          </Row>

          <Row>
            <div className="container-input-avatar">
              <input type="file" className="input-file-avatar" onChange={e => setFile(e.target.files[0])} />
              <div className="avatar-circle">
                <div className="tapa"></div>
                {!item.avatar_url && !loadingAvatar ? <><h1>{item?.first_name?.slice(0, 1)}</h1>
                  <h1>{item?.last_name?.slice(0, 1)}</h1></> : <img src={`${routeImage + '/' + item.avatar_url}?t=${new Date().getTime()}`} alt="" />}
                {loadingAvatar ? (<div className="container-avatar-spiner">
                  < Spinner style={{
                    height: '4rem',
                    width: '4rem'
                  }} color="success">
                    Loading...
                  </Spinner></div>) : null}
                <i id="excluir-click" className={!isViewUploadMenu ? "fa fa-pencil" : "fa fa-close"} aria-hidden="true"   >
                  {/* <div className="drop-user-input">
                  
                        </div> */}
                </i>
                {isViewUploadMenu ? (<div ref={contenedorRef} className="overlay-menu">
                  <div > <label htmlFor="file-upload" className="boton-personalizado">
                    Subir desde: Mis archivos
                  </label>
                    <input
                      id="file-upload"
                      type="file"
                      style={{ display: 'none' }}
                      onChange={e => handleUpload(e.target.files[0])}
                    /></div>

                  {itemSocial.twitter_username ? (<div onClick={() => getImage(itemSocial.twitter_username, "x")}>Subir desde: Twitter /  𝕏</div>) : null}
                </div>) : null}
              </div>


            </div>

          </Row>

          <Row>
            <Col>
              <FormGroup>
                <Label> {t("Nombre")}</Label>
                <input
                  className={`form-control ${errors.first_name && "is-invalid"
                    }`}
                  type="text"
                  required=""
                  placeholder="Ingresa el nombre del contacto"
                  autoComplete="off"
                  {...register("first_name", {
                    required: "El nombre es obligatorio",
                  })}
                />
                <InputError errors={errors} name="first_name" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label>{t("Apellido")}</Label>
                <input
                  className={`form-control ${errors.last_name && "is-invalid"}`}
                  type="text"
                  required=""
                  placeholder="Ingresa el apellido del contacto"
                  autoComplete="off"
                  {...register("last_name", {
                    required: "El apellido es obligatorio",
                  })}
                />
                <InputError errors={errors} name="last_name" />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormGroup>
                <Label htmlFor="contact_charge_id" className="form-label">
                  {t("Cargo")}
                </Label>

                <Select
                  onChange={handleChangeCharge}
                  options={charges}
                  search="true"
                  name="charge"
                  placeholder="Filtrar por cargo"
                  isClearable="true"
                  getOptionLabel={(option) => option?.name}
                  getOptionValue={(option) => option?.id}
                  value={charge}
                  className={`form-select ${errors.contact_charge_id && "is-invalid"
                    }`}
                />
                <input
                  type="hidden"
                  name="contact_charge_id"
                  {...register("contact_charge_id", {
                    required: "El cargo es obligatorio",
                  })}
                  id="contact_charge_id"
                ></input>

                <InputError errors={errors} name="contact_charge_id" />
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  );
};
export default BasicData;
